import {BusinessModel} from '../business/business-model';
import {AddressModel} from '../address/address-model';
import {TagSerialNumberTokenModel} from '../shared/tag-serial-number-token-model';

export interface WheelGameModel {
  _id: string;
  created_date: Date;
  business: BusinessModel;
  slices: WheelGameSliceModel [];
  target: WheelGameTargetList;
  suspension_date?: Date;
  resources: WheelGameResourceModel [];
  public_id: string;
}

export interface WheelGameSliceModel {
  _id: string;
  customizer: WheelGameSliceCustomizerModel;
  type: WheelGameSliceTypeList;
  value?: string;
  deleted_date?: Date;
}

export interface WheelGameSliceCustomizerModel {
  background: string;
  color: string;
}

export enum WheelGameTargetList {
  GOOGLE = 'GOOGLE',
  INSTAGRAM = 'INSTAGRAM',
  TRUST_PILOT = 'TRUST_PILOT'
}

interface WheelGameResourceModel {
  url: string;
  address: AddressModel;
  deactivated_date?: Date;
}

export enum WheelGameSliceTypeList {
  LOST = 'LOST',
  REWARD = 'REWARD'
}

export interface WheelGameCreateModel {
  business: string;
  slices: Array<Omit<WheelGameSliceModel, '_id' | 'deleted_date'>>;
  target: WheelGameTargetList;
  resources: Array<Omit<WheelGameResourceModel, 'address' | 'deactivated_date'> & { address: string }>;
}

export interface WheelGameUpdateModel {
  slices?: Array<Omit<WheelGameSliceModel, '_id' | 'deleted_date'> & {_id?: string}>;
  target?: WheelGameTargetList;
  resources?: Array<Omit<WheelGameResourceModel, 'address' | 'deactivated_date'> & { address: string; deactivate?: boolean }>;
}

export interface SliceFormModel {
  color: string,
  background: string,
  type: WheelGameSliceTypeList,
  value?: string
}

export interface WheelGameAddressStat {
  address_id: string;
  formatted_address: string;
  number_of_visit: number;
  number_of_reward: number;
  number_of_earned_rewards: number;
  deactivated_date?: Date;
}

export interface LoyaltyCardWheelGamesAndWheelRewards {
  wheelGames: WheelPublicIdAndResources [];
  wheelRewards: WheelRewardModel [];
}

export interface WheelPublicIdAndResources {
  public_id: string;
  resources: WheelGameResourceModel[]
}

export interface WheelRewardModel {
  _id: string;
  value: string;
}

export interface EarnWheelGameResultWithTagModel {
  tag: TagSerialNumberTokenModel;
  wheel_result_id: string;
}

export interface WheelGameResultModel {
  _id: string;
  created_date: Date;
  wheel: string;
  slice: string;
  player?: string;
  address: string;
  earn_date?: Date;
  invalidation_date?: Date;
}
